export const tituloVentanaServicio = "Administración Servicios";
export const tituloVentanaGlosas = "Administración Glosas";
export const tituloVentanaParametros = "Administración Parámetros";
export const tituloVentanaCargaAfiliacion = "Envió de Empresas a SAT";
export const tituloVentanaCargaMora = "Envió de Periodo en Mora a SAT";
export const tituloVentanaCargaRetiro = "Envió de Retiro Definitivo a SAT";





// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/modelo/TextoVentanaAyuda.ts